import { g as u } from "./chunk.DaMA6jEr.js";
import { _ as g, i as y, a as f, b as m } from "./chunk.BK-hwjME.js";
function S(r, t) {
  for (var n = -1, o = r == null ? 0 : r.length, i = Array(o); ++n < o; )
    i[n] = t(r[n], n, r);
  return i;
}
var l = S, p = g, c = y, d = "[object Symbol]";
function _(r) {
  return typeof r == "symbol" || c(r) && p(r) == d;
}
var T = _, e = f, v = l, I = m, $ = T, j = 1 / 0, a = e ? e.prototype : void 0, s = a ? a.toString : void 0;
function b(r) {
  if (typeof r == "string")
    return r;
  if (I(r))
    return v(r, b) + "";
  if ($(r))
    return s ? s.call(r) : "";
  var t = r + "";
  return t == "0" && 1 / r == -j ? "-0" : t;
}
var h = b, q = h;
function x(r) {
  return r == null ? "" : q(r);
}
var A = x, M = A, k = 0;
function C(r) {
  var t = ++k;
  return M(r) + t;
}
var F = C;
const N = /* @__PURE__ */ u(F);
export {
  N as u
};
